<template>
	<ul class="bubble-tags searchTagsDisplay">
		<li v-for="(data, index) in tags" :key="index" class="searchFilterTag" :data-filter="data.filter">{{data.valueDisplay}}</li>
		<div class="clearfix"></div>
	</ul>
</template>

<script>
	import {getKeyNames,determineNameValueDisplay} from "@js/parts/search/functions/searchfilterbox/updateTagsView";
	import {mapState} from 'vuex';
	import getExcludedSearchFilters from "@js/parts/search/functions/searchfilterbox/getExcludedSearchFilters";
	export default {
		computed:{
			...mapState({
				search: 'search',
			}),
			tags(){
				const excluded = getExcludedSearchFilters();

				const names = getKeyNames();
				const selected = this.search.parameters;
				const keys = Object.keys(selected);
				let tags = [];

				if (keys.length !== 0) {

					for (let i = 0; i < keys.length; i++) {
						if(excluded.indexOf(keys[i]) !== -1)
							continue;

						let value = (keys[i] === 'ankomst' && typeof selected['specificAnkomst'] !== 'undefined') ? selected['specificAnkomst'] : selected[keys[i]];
						const nameValueDisplay = determineNameValueDisplay(keys[i], value, names);
						tags.push({
							filter: $("<div>").text(keys[i]).html(),
							valueDisplay: nameValueDisplay
						});
					}
				}
				return tags;
			}
		}
	};
</script>

<style scoped>

</style>
